import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Navbar() {
  const navigate = useNavigate();
  const userType = localStorage.getItem('userType') || 'student';

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom py-3">
      <div className="container">
        {/* Logo with gradient text */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img 
            src="/logo.png" 
            alt="EduLinker" 
            className="navbar-logo"
          />
          {/* Gradient text - will show now */}
          {/* <span className="navbar-brand-text">
            EduSpace
          </span> */}
        </Link>

        {/* Right Side Navigation */}
        <div className="d-flex align-items-center">
          {/* Dashboard Link */}
          {userType === 'student' && (
            <Link to="/student" className="nav-link me-4 text-dark">
              <i className="fas fa-home fa-lg"></i>
            </Link>
          )}
          {userType === 'teacher' && (
            <Link to="/teacher" className="nav-link me-4 text-dark">
              <i className="fas fa-home fa-lg"></i>
            </Link>
          )}
          {userType === 'parent' && (
            <Link to="/parent" className="nav-link me-4 text-dark">
              <i className="fas fa-home fa-lg"></i>
            </Link>
          )}
          {userType === 'admin' && (
            <Link to="/admin" className="nav-link me-4 text-dark">
              <i className="fas fa-cogs fa-lg"></i>
            </Link>
          )}
          
          {/* Logout Button */}
          <button 
            className="btn btn-outline-danger px-3" 
            onClick={handleLogout}
            title="Logout"
          >
            <i className="fas fa-sign-out-alt me-1"></i> Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;